import { ErrorHandler, NgModule, provideZoneChangeDetection } from '@angular/core';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';
import { BrowserModule } from '@angular/platform-browser';

// search module

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { PagesModule } from "./pages/pages.module";
// progress
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
// Notifier
import { NotifierModule, NotifierOptions } from 'angular-notifier';
// Auth
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';
import { LongRunningRequestInterceptor } from './core/interceptors/long-running-request.interceptor';


// Language
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { FlatpickrModule } from 'angularx-flatpickr';
import { APP_VERSION } from 'src/version';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/i18n/', `.json?v=${APP_VERSION}`);
}

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'bottom',
      distance: 12,
      gap: 10
    },
  },
  theme: 'material', // Better styling
  behaviour: {
    autoHide: false, // We will manually handle auto-hide in the service
    onClick: 'hide',
    showDismissButton: true,
    stacking: 4
  },
}

@NgModule({
  declarations: [
    AppComponent
  ],
  exports: [],
  bootstrap: [AppComponent], imports: [TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [HttpClient]
    }
  }),
  FlatpickrModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    PagesModule,
  NgProgressModule.withConfig({
    color: "#1e6ef5",
    direction: "ltr+",
    ease: "linear",
    thick: true,
    fixed: true,
    spinner: false
  }),
    NgProgressRouterModule,
    NgProgressHttpModule,
  NotifierModule.withConfig(customNotifierOptions),
    OverlayModule], providers: [
      // Global Error Handler - catches chunk loading errors and auto-refreshes
      {
        provide: ErrorHandler,
        useClass: GlobalErrorHandler
      },
      AuthService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: LongRunningRequestInterceptor,
        multi: true
      },
      provideHttpClient(withInterceptorsFromDi()),
      provideZoneChangeDetection({ eventCoalescing: true })
    ]
})
export class AppModule { }
